import React, { useEffect, useRef } from 'react';
import styles from './Aboutus.module.css';
import bannerImage from '../../shreeombanner.jpeg';
import StoreOne from '../../storeshree.jpeg';
import StoreTwo from '../../storeshree2.jpeg'
import StoreThree from '../../storeshree3.jpeg'
import StoreSatu from '../../satushree.jpeg'
import Supplements from '../../supplements.jpeg'
import WorkingImage from '../../workingshree.jpeg'



import { FaLeaf, FaMountain, FaTruck, FaHeart, FaMapMarkerAlt } from 'react-icons/fa';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Usrnav from '../../usercomponents/Usrnav/Usrnav';
import { FiChevronDown } from 'react-icons/fi';

gsap.registerPlugin(ScrollTrigger);

const AboutUs = () => {
  
const mapUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1412.0050840531516!2d81.6072668!3d28.5950486!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39a2850018d1b611%3A0x15cc81f7fdfa88c1!2sShree%20Om%20Organic%20Devine%20Enterprises!5e1!3m2!1sen!2snp!4v1717400000000!5m2!1sen!2snp";

  
  // Content refs
  const containerRef = useRef(null);
  const heroRef = useRef(null);
  const missionRef = useRef(null);
  const featuresRef = useRef(null);
  const storyRef = useRef(null);
  const galleryRef = useRef(null); // New gallery ref
  const locationRef = useRef(null);
  const ctaRef = useRef(null);
  const featureCardsRef = useRef([]);
  const galleryImagesRef = useRef([]); // New gallery images ref
  
  // Landscape refs
  const mountainsRef = useRef(null);
  const hillsRef = useRef(null);
  const cloudsRef = useRef(null);

 useEffect(() => {
  // Clear existing animations
  ScrollTrigger.getAll().forEach(t => t.kill());
  gsap.killTweensOf("*");

  // Helper function for forward-only animations
  const animateForward = (element, fromVars, toVars, scrollOptions) => {
    if (!element) return;
    
    gsap.fromTo(element, 
      { ...fromVars, immediateRender: false },
      {
        ...toVars,
        scrollTrigger: {
          ...scrollOptions,
          toggleActions: "play none none none" // Only play on enter
        }
      }
    );
  };

  // Landscape animations (forward only)
  if (mountainsRef.current) {
    gsap.to(mountainsRef.current, {
      y: 150,
      ease: "none",
      scrollTrigger: {
        trigger: containerRef.current,
        start: "top top",
        end: "bottom bottom",
        scrub: 1.5,
        toggleActions: "play none none none"
      }
    });
  }

  if (hillsRef.current) {
    gsap.to(hillsRef.current, {
      y: 80,
      ease: "none",
      scrollTrigger: {
        trigger: containerRef.current,
        start: "top top",
        end: "bottom bottom",
        scrub: 1,
        toggleActions: "play none none none"
      }
    });
  }

  if (cloudsRef.current) {
    gsap.to(cloudsRef.current, {
      x: 100,
      opacity: 0.7,
      ease: "none",
      scrollTrigger: {
        scrub: 0.5,
        toggleActions: "play none none none"
      }
    });
  }

  // Content sections (forward only)
  const animateSection = (ref, x = 0, y = 50) => {
    if (!ref.current) return;
    animateForward(
      ref.current,
      { opacity: 0, x, y },
      { opacity: 1, x: 0, y: 0, duration: 1 },
      { trigger: ref.current, start: "top 80%" }
    );
  };

  animateSection(missionRef);
  animateSection(featuresRef, 0, 30);
  animateSection(storyRef, -50, 0);
  animateSection(galleryRef, 50, 0);
  animateSection(locationRef, 50, 0);
  
  // Feature cards (forward only)
  if (featuresRef.current && featureCardsRef.current) {
    featureCardsRef.current.forEach((card, i) => {
      if (!card) return;
      animateForward(
        card,
        { opacity: 0, y: 50 },
        { 
          opacity: 1, 
          y: 0, 
          duration: 0.8,
          delay: i * 0.15 
        },
        { 
          trigger: featuresRef.current, 
          start: "top 70%" 
        }
      );
    });
  }

  // Gallery animations (forward only)
 // In your gallery animations array, replace the second image animation (index 1) with this:
if (galleryImagesRef.current) {
  const galleryAnimations = [
    // Image 1 - Scale up (keep existing)
    (el) => animateForward(
      el,
      { scale: 0.8, opacity: 0, rotationX: 15 },
      { 
        scale: 1, 
        opacity: 1, 
        rotationX: 0, 
        duration: 1.2,
        ease: "back.out(1.2)" 
      },
      { trigger: el, start: "top 85%" }
    ),
    
    // Image 2 - Superhero landing effect

    (el) => {
  // Initial hidden state
  gsap.set(el, {
    scale: 0.8,
    opacity: 0,
    rotationX: 15,
    visibility: "hidden",
    transformOrigin: "center center",
  });

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: el,
      start: "top 85%",
      toggleActions: "play none none none",
      markers: false,
      onEnter: () => gsap.set(el, { visibility: "visible" }),
    },
  });

  // Animate in
  tl.to(el, {
    scale: 1,
    opacity: 1,
    rotationX: 0,
    duration: 1.2,
    ease: "back.out(1.2)",
  });
}
,
    
    // Image 3 - Staggered scale
    (el) => {
      const img = el.querySelector(`.${styles.galleryImage}`);
      const desc = el.querySelector(`.${styles.imageDescription}`);
      if (img && desc) {
        animateForward(
          [img, desc],
          { scaleY: 0.5, opacity: 0, transformOrigin: "center bottom" },
          { 
            scaleY: 1, 
            opacity: 1, 
            duration: 0.8,
            stagger: 0.2,
            ease: "elastic.out(1, 0.5)" 
          },
          { trigger: el, start: "top 75%" }
        );
      }
    },
    // Image 4 - Bounce down
    (el) => animateForward(
      el,
      { y: -200, opacity: 0, rotationZ: 10 },
      { 
        y: 0, 
        opacity: 1, 
        rotationZ: 0, 
        duration: 1.3,
        ease: "bounce.out" 
      },
      { trigger: el, start: "top 85%" }
    ),
    // Image 5 - Rotating zoom
    (el) => animateForward(
      el,
      { scale: 0.7, opacity: 0, rotation: 15 },
      { 
        scale: 1, 
        opacity: 1, 
        rotation: 0, 
        duration: 1.4,
        ease: "elastic.out(1, 0.7)" 
      },
      { trigger: el, start: "top 80%" }
    )
  ];

  // Rest of your code remains the same...
  galleryImagesRef.current.forEach((el, i) => {
    if (!el) return;
    const anim = galleryAnimations[i] || galleryAnimations[0];
    anim(el);
  });
}
  // Hero animation (forward only)
  if (heroRef.current) {
    gsap.from(heroRef.current, {
      duration: 1.5,
      opacity: 0,
      y: 50,
      ease: "power3.out"
    });
  }

  return () => {
    ScrollTrigger.getAll().forEach(t => t.kill());
    gsap.killTweensOf("*");
  };
}, []);

  return (
    <div className={styles.abtbody} ref={containerRef}>
      <div className="nav-wrapper">
        <Usrnav />
      </div>
      
      {/* Animated Landscape Background */}
      <div className={styles.landscape}>
        {/* Clouds */}
        <svg ref={cloudsRef} className={styles.clouds} viewBox="0 0 1200 200" preserveAspectRatio="none">
          <path d="M0,100 C150,50 250,150 400,80 C550,150 650,50 800,120 C950,50 1050,150 1200,100" 
                fill="rgba(255,255,255,0.3)" />
        </svg>
        
        {/* Mountains */}
        <svg ref={mountainsRef} className={styles.mountains} viewBox="0 0 1200 400" preserveAspectRatio="none">
          <path d="M0,400 L200,250 L400,350 L600,200 L800,300 L1000,150 L1200,250 L1200,400 Z" 
                fill="#3a5c6e" />
          <path d="M0,400 L100,300 L300,350 L500,250 L700,300 L900,200 L1100,250 L1200,200 L1200,400 Z" 
                fill="#2d4a5a" opacity="0.8" />
        </svg>
        
        {/* Hills */}
        <svg ref={hillsRef} className={styles.hills} viewBox="0 0 1200 300" preserveAspectRatio="none">
          <path d="M0,300 L150,220 L350,250 L550,200 L750,240 L950,180 L1150,220 L1200,200 L1200,300 Z" 
                fill="#4a7c8a" opacity="0.7" />
        </svg>
      </div>

      {/* Page Content */}
      <div className={styles.aboutContainer}>
        <div 
          ref={heroRef}
          className={styles.heroSection}  
          style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${bannerImage})`
          }}
        >
          <h1>About <span>ShreeOhm</span></h1>
          <p>Your Trusted Source for Organic & Natural Goodness</p>
        </div>

        <div className={styles.contentSection}>
          <section ref={missionRef} className={styles.missionSection}>
            <h2>ABOUT  SHEEOHM</h2>
          <p>
  <strong>ShreeOhm</strong> is trusted source for authentic <strong>Karnali organic products</strong> in Nepal. Located in <strong>Birendranagar, Surkhet</strong>, we specialize in premium organic food items such as <strong>Jumli Simi (Beans)</strong>, <strong>Marsi rice</strong>, and other locally grown grains and superfoods. As one of the leading <strong>organic stores in Nepal</strong>, our mission is to bring you high-quality, chemical-free, and eco-friendly products directly from the untouched hills of the <strong>Karnali region</strong>. From <strong>pure honey</strong> and <strong>Himalayan herbs</strong> to <strong>Ayurvedic remedies</strong> and <strong>natural wellness products</strong>, ShreeOhm promotes healthy living while preserving the biodiversity of Nepal. Searching for <em>"Karnali Organic"</em>, <em>"organic food in Nepal"</em>, or <em>"Marsi rice and beans online"</em>? You've come to the right place.
</p>

            <p><FiChevronDown/></p>
          </section>

          <section ref={featuresRef} className={styles.featuresSection}>
            <h2>Why Choose ShreeOhm?</h2>
            <div className={styles.featuresGrid}>
              <div ref={el => featureCardsRef.current[0] = el} className={styles.featureCard}>
                <FaLeaf className={styles.icon} />
                <h3>100% Organic & Natural</h3>
                <p>Free from harmful chemicals and artificial additives</p>
              </div>
              <div ref={el => featureCardsRef.current[1] = el} className={styles.featureCard}>
                <FaMountain className={styles.icon} />
                <h3>Direct from Karnali</h3>
                <p>Supporting local farmers and traditions</p>
              </div>
              <div ref={el => featureCardsRef.current[2] = el} className={styles.featureCard}>
                <FaHeart className={styles.icon} />
                <h3>Premium Himalayan Herbs</h3>
                <p>Handpicked for medicinal and nutritional value</p>
              </div>
              <div ref={el => featureCardsRef.current[3] = el} className={styles.featureCard}>
                <FaTruck className={styles.icon} />
                <h3>Reliable Delivery</h3>
                <p>Fast shipping across Nepal and beyond</p>
              </div>
            </div>
          </section>

          <section ref={storyRef} className={styles.storySection}>
       
            <h2>Our Service – Authentic Karnali Organic Products</h2>
<p>ShreeOhm offers a wide selection of authentic organic products sourced directly from Karnali, including <strong>Yarsagumba</strong>, <strong>Shilajit</strong>, <strong>Keshar</strong>, <strong>Jumla apples</strong>, <strong>Marsi (brown rice)</strong>, <strong>Simi (beans)</strong>, and <strong>Okhar (walnuts)</strong>. Our mission is to connect you with the rich natural treasures of Karnali by providing fresh, chemical-free goods through a reliable home delivery service. With a focus on purity, wellness, and sustainability, we make it easy for customers across Nepal to access high-quality Karnali organic products at their doorstep.</p>

          </section>

          {/* New Image Gallery Section */}
          <section ref={galleryRef} className={styles.gallerySection}>
  <h2>Shree Ohm Organic And Devine Center</h2>
  <div className={styles.galleryContainer}>
    <div className={styles.galleryGrid}>
      {/* Image 1 - Left (60% width) */}
      <div ref={el => galleryImagesRef.current[0] = el} className={`${styles.galleryItem} ${styles.full}`}>
        <img src={StoreOne} alt="ShreeOhm" className={styles.galleryImage} />
        <div className={styles.imageDescription}><h3>ShreeOhm Products</h3>
        <br />
        <p>
  <strong>ShreeOhm</strong> offers a carefully curated selection of <strong>Karnali organic products </strong> that highlight the natural richness of Nepal. From Ayurvedic supplements and Himalayan herbs to organic grains and eco-friendly daily essentials, every item is sourced from trusted local producers in the Karnali region. As one of the best organic stores in Nepal, we ensure <strong> <a href="/ourproducts">our products</a></strong> are free from chemicals, traditionally prepared, and sustainably packaged. Whether you're searching for <strong>authentic herbal items from Karnali </strong> , <strong>organic spices</strong>, or <strong>natural wellness goods in Nepal </strong>, ShreeOhm stands as a reliable destination for purity and health. Our goal is to make <strong>Karnali organic </strong> accessible to every household that values nature and well-being.
</p>

        </div>
      </div>
      
      {/* Image 2 - Right (60% width) */}
      <div ref={el => galleryImagesRef.current[1] = el} className={`${styles.galleryItem} ${styles.right}`}>
         <img src={StoreTwo} alt="ShreeOhm" className={styles.galleryImage} />
        <div className={styles.imageDescription}>
  <h3>Groceries</h3>
  <p>
    Our grocery section offers a curated selection of <strong>Ayurvedic and organic daily essentials</strong> for your kitchen and home. From <strong>aromatic spices</strong> and <strong>protein-rich lentils</strong> to <strong>natural cooking oils</strong>, herbal soaps, and <strong>wholesome packaged food items</strong>, each product is selected to support a healthy and balanced lifestyle. With a focus on <strong>natural ingredients</strong> and traditional wellness, our groceries bring together quality, convenience, and Ayurveda in one place. Whether you're restocking pantry staples or seeking <strong>Ayurvedic grocery products in Nepal</strong>, you'll find everything you need right here.
  </p>
</div>

      </div>
      
      {/* Image 3 - Full width (90%) */}
      <div ref={el => galleryImagesRef.current[2] = el} className={`${styles.galleryItem} ${styles.full}`}>
       <img src={StoreThree} alt="ShreeOhm" className={styles.galleryImage} />
       <div className={styles.imageDescription}>
  <h3>Herbal Products</h3>
  <br />
  <p>
    Discover our range of <strong>Karnali herbal products</strong>, made with care using traditional Ayurvedic methods and the finest <strong>organic herbs from Nepal</strong>. From <strong>aromatic herbal teas</strong> and <strong>healing balms</strong> to <strong>natural remedies</strong> and wellness blends, every item is sustainably sourced from the untouched landscapes of the <strong>Karnali region</strong>. Crafted to preserve ancient wisdom and promote modern health, these <strong>natural herbal products</strong> offer a genuine connection to Nepal’s rich biodiversity and holistic living.
  </p>
</div>

      </div>

       <div ref={el => galleryImagesRef.current[3] = el} className={`${styles.galleryItem} ${styles.full}`}>
        <div className={styles.imageDescription}><h3>Processing</h3><br/>
        <p>Our hands-on grain and herb processing in action. With care and precision, our team uses clean, small-scale machinery to grind and prepare natural ingredients while maintaining their purity and nutritional value. We combine traditional wisdom with simple modern tools to ensure that each product you receive is wholesome, hygienic, and close to nature.</p></div>
         <img src={WorkingImage} alt="ShreeOhm" className={styles.galleryImage} />
        
      </div>
      
      {/* Image 4 - Right (60% width) */}
      <div ref={el => galleryImagesRef.current[4] = el} className={`${styles.galleryItem} ${styles.right}`}>
        <img src={Supplements } alt="ShreeOhm" className={styles.galleryImage} />
         <div className={styles.imageDescription}>
  <h3>Supplements</h3>
  <br />
  <p>
    Explore our wide range of <strong>natural herbal supplements</strong> in Nepal, designed to support <strong>holistic health and wellness</strong>. Each supplement is made using <strong>locally sourced ingredients</strong> from the <strong>Karnali region</strong> and follows traditional <strong>Ayurvedic principles</strong>. Whether you're looking for <strong>immunity boosters</strong>, <strong>digestive health remedies</strong>, or overall <strong>natural wellness supplements</strong>, our products are processed with care and integrity. Trusted by those seeking <strong>authentic Ayurvedic supplements in Nepal</strong>, ShreeOhm is your reliable source for quality herbal care.
  </p>
</div>

      </div>
      
      {/* Image 5 - Left (60% width) */}
      <div ref={el => galleryImagesRef.current[5] = el} className={`${styles.galleryItem} ${styles.full}`}>
         <img src={StoreSatu} alt="ShreeOhm" className={styles.galleryImage} />
         <div className={styles.imageDescription}>
  <h3>Karnali Special Products</h3>
  <br />
  <p>
    Our <strong>Karnali Special products</strong> are directly sourced from the pristine hills and farms of Nepal’s <strong>Karnali region</strong>. These include <strong>Herbal teas</strong>, <strong>Jumli beans</strong>, <strong> Apis Laboriosa Honey(Bhir Maha)</strong>, <strong>Yarsagumba</strong>, <strong>Shilajeet</strong>, <strong>Marsi rice</strong>, <strong>Chino</strong>,<strong>Kaguno</strong>, and other <strong>organic superfoods</strong> that reflect the untouched purity and traditional farming methods of the region. Each product is naturally grown, chemical-free, and full of authentic flavor and nutrition. When you choose <strong>Karnali organic food</strong>,  you’re supporting local farmers and embracing a healthier, more sustainable lifestyle rooted in Nepal’s rich food heritage.
  </p>
</div>



      </div>
    </div>
  </div>
</section>

          <section ref={locationRef} className={styles.locationSection}>
            <h2>Find Us</h2>
            <div className={styles.mapContainer}>
              <iframe 
                src={mapUrl}
                width="100%" 
                height="450" 
                style={{border:0}} 
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                title="ShreeOhm Location"
              ></iframe>
            </div>
            <div className={styles.locationInfo}>
              <FaMapMarkerAlt className={styles.mapIcon} />
              <div>
                <h3>Our Store</h3>
                <p>ShreeOhm Organic Store</p>
                <p>Birendranagar-10, Surkhet</p>
                <p>Karnali Province, Nepal</p>
              </div>
            </div>
          </section>

          <section ref={ctaRef} className={styles.ctaSection}>
            <h2>Join Our Journey</h2>
            <p>
              We invite you to explore our collection, embrace a healthier lifestyle, 
              and become part of the ShreeOhm family.
            </p>
            <div className={styles.tagline}>
              <FaLeaf /> <span>Eat Pure. Live Well. Stay Natural.</span> <FaLeaf />
            </div>
            <div className={styles.contactInfo}>
              <p><strong>Location:</strong> Birendranagar, Surkhet, Nepal</p>
              <p><strong>Email:</strong> shreeohm083@gmail.com</p>
              <p><strong>Phone:</strong> +977-9858060350</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
